<template>
  <div>Product Array: {{ JSON.stringify(products) }}</div>
</template>

<script>
import { fsdb } from '../../firestore';

export default {
  name: 'ProductArrayComp',
  props: {
    orderSessionId: String,
    suborderId: String
  },

  mounted() {
    this.$bind('products', fsdb.collection(`parties/${this.orderSessionId}/suborders/${this.suborderId}/products`));
  },

  data() {
    return {
      products: []
    };
  }

}
</script>

<style scoped>

</style>